import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Form from '@/components/base/form'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'
import { newsletterRevealAnimation } from '@/components/sections/animations/newsletter'
import Spacer from '@/components/sections/spacer'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type NewsletterProps = HTMLAttributes<HTMLDivElement>

const Newsletter = ({ ...props }: NewsletterProps) => {
  const { strings } = useStore()
  const { title, form } = strings?.newsletter || {}

  return (
    <Motion animation={newsletterRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} className={cn('', {})} {...props}>
          <Spacer variant="xxl" />
          <Spacer variant="xxl" />
          <Container>
            <Grid className="gap-y-[2.5rem]">
              <div className={cn('col-span-2 md:col-span-2 lg:col-span-3')}>
                <div className="grid gap-y-[2rem]">
                  {title ? (
                    <Typography
                      variant="h3"
                      component="h2"
                      className="text-s-h4 md:text-s-h3"
                      data-motion-title
                    >
                      {title}
                    </Typography>
                  ) : null}
                </div>
              </div>

              <div className="col-span-2 md:col-span-4 lg:col-span-9">
                <Form
                  form_id={form?.id}
                  fields={form?.fields}
                  submit={form?.button?.text}
                  variant="newsletter"
                  data-motion-form
                  cta_button
                  className={cn(
                    'relative gap-y-[1.6rem]',
                    '[&_.col-span-2:first-child_input]:border-[2px]',
                    '[&_[data-form-submit]]:absolute [&_[data-form-submit]]:right-0 [&_[data-form-submit]]:top-0 [&_[data-form-submit]_button]:mt-0 [&_[data-form-submit]_button]:justify-center [&_[data-form-submit]_svg]:!size-[24px]',
                    '[&_[data-form-submit]_button]:size-[46px] md:[&_[data-form-submit]_button]:size-[70px]',
                    '[&_.col-span-2:first-child]:w-[calc(100%-54px)] md:[&_.col-span-2:first-child]:w-[calc(100%-78px)] [&_.col-span-2:first-child_input]:h-[46px] md:[&_.col-span-2:first-child_input]:h-[70px]',
                    'mb-0 md:mb-[-100px]'
                  )}
                />
              </div>
            </Grid>
          </Container>
          <Spacer variant="xxl" />
          <Spacer variant="xxl" />
        </Section>
      )}
    </Motion>
  )
}

export default Newsletter
